
import breathingAudio from "@/assets/audios/Breathing-exercise.m4a";
import type { SegmentExerciseData } from "../types/exercise";

export const breathingData: SegmentExerciseData[] = [
  {
    id: 1,
    segment: { start: 0, end: 73 },
    titleKey: "breathing.step1.title",
    content: "breathing.step1.description",
    exerciseType: "timed_audio",
    audio: breathingAudio,
  },
  {
    id: 2,
    segment: { start: 73, end: 106 },
    titleKey: "breathing.step2.title",
    content: "breathing.step2.description",
    exerciseType: "timed_audio",
    audio: breathingAudio,
  },
  {
    id: 3,
    segment: { start: 106, end: 133 },
    titleKey: "breathing.step3.title",
    content: "breathing.step3.description",
    exerciseType: "timed_audio",
    audio: breathingAudio,
  },
  {
    id: 4,
    segment: { start: 133, end: 149 },
    titleKey: "breathing.step4.title",
    content: "breathing.step4.description",
    exerciseType: "timed_audio",
    audio: breathingAudio,
  },
  {
    id: 5,
    segment: { start: 149, end: 166 },
    titleKey: "breathing.step5.title",
    content: "breathing.step5.description",
    exerciseType: "timed_audio",
    audio: breathingAudio,
  },
  {
    id: 6,
    segment: { start: 166, end: 177 },
    titleKey: "breathing.step6.title",
    content: "breathing.step6.description",
    exerciseType: "timed_audio",
    audio: breathingAudio,
  },
  {
    id: 7,
    segment: { start: 177, end: 208 },
    titleKey: "breathing.step7.title",
    content: "breathing.step7.description",
    exerciseType: "timed_audio",
    audio: breathingAudio,
  },
];


export function getActiveSegment(currentTime: number): number {
  for (let i = 0; i < breathingData.length; i++) {
    const segment = breathingData[i];
    if (
      currentTime >= segment.segment.start &&
      currentTime < segment.segment.end
    ) {
      return i;
    }
  }
  return breathingData.length - 1;
}
